<template>
    <div class="wrapper autoshow">
        <div class="auto_img">
            <img :src="template.head_m" alt="头图">
        </div>
        <!--        head_img end-->
        <div class="sign_form" :style="`backgroundColor: ${template.middle_m}`">
            <ul class="count_time" v-if="template.is_count">
                <li>车展倒计时：</li>
                <li><span>{{count_day}}</span>天</li>
                <li><span>{{count_hour}}</span>时</li>
                <li><span>{{count_minute}}</span>分</li>
                <li><span>{{count_second}}</span>秒</li>
            </ul>
            <!--        count_time end-->
            <el-form
                    :model="action_form"
                    :rules="rules"
                    ref="action_form"
                    hide-required-asterisk
            >
                <el-form-item>
                    <div class="search_cars" @click="clk_brand()" :class="{is_black:is_carchecked}">
                        {{ checkedBrand }}
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </el-form-item>

                <el-form-item prop="name">
                    <el-input
                            v-model="action_form.name"
                            placeholder="请输入姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="phone">
                    <el-input
                            v-model="action_form.phone"
                            placeholder="请输入电话"
                            type="number"
                    ></el-input>
                </el-form-item>

                <el-form-item class="redpacket_code" v-if="ismsgcode == 1">
                    <el-input
                            v-model="action_form.code"
                            placeholder="请输入验证码"
                            type="number"
                    ></el-input>
                    <el-button type="primary" size="small" @click="send" :disabled="disabled_code">
                        {{countDown}}
                    </el-button>
                </el-form-item>

                <el-form-item prop="city" class="margin_cus" v-if="is_city">
                    <el-cascader
                            placeholder="快速选择城市"
                            :options="citys"
                            :props="cascaderProps"
                            v-model="action_form.city"
                            ref="bind_city_ref"
                            filterable
                            style="width: 100%"
                    ></el-cascader>
                </el-form-item>
                <!--                隐私声明-->
                <policy></policy>

                <el-form-item class="form_btn">
                    <el-button @click="submitForm()" :disabled="is_overdue" :class="{opacity: is_overdue}"
                               :style="`backgroundColor: ${template.button_bg_color}; color:${template.button_font_color};`"
                    >
                        <span v-if="is_overdue">活动已结束</span>
                        <span v-else>{{template.button_title}}</span>
                    </el-button
                    >
                </el-form-item>
            </el-form>
            <registered v-if="template.is_banner == 1"></registered>
        </div>
        <!--        sign_form end-->

        <div class="auto_img">
            <img :src="template.tail_m" alt="详情图">
        </div>
        <!--        info_img end-->

        <div class="back_top" @click="toTop" :class="{is_btm_btn: is_display}">
            <span>{{ template.bottom_button_title }}</span>
        </div>

        <copyright v-if="template.is_copyright == 1"></copyright>

        <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible" class="brand_dialog">
            <div v-if="isShow" class="brand_wrap">
                <div class="letters">
                    <ul>
                        <li
                                v-for="(list, letter) in car_list"
                                :key="letter"
                                @click="toLetter(letter)"
                                :class="isactive == letter ? 'cur' : ''"
                        >
                            {{ letter }}
                        </li>
                    </ul>
                </div>
                <!-- letters end -->
                <div class="carslist">
                    <template v-for="(brands, letter) in car_list">
                        <div :key="letter">
                            <div class="character" :id="'letter_' + letter">
                                {{ letter }}
                            </div>
                            <ul class="car_tree">
                                <li
                                        v-for="brand in brands"
                                        :key="brand.id"
                                        @click="toCarlist(brand)"
                                >
                                    <img :src="brand.logo" alt="" />
                                    <span>{{ brand.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </template>
                </div>
            </div>

            <div v-else class="carlist" id="dialog_view">
                <div class="carBack" @click="isShow = true">返回</div>
                <template v-for="(automaker, automaker_id) in car_object.children">
                    <div :key="automaker_id">
                        <h3>{{ automaker.name }}</h3>
                        <ul>
                            <li
                                    v-for="(series, series_id) in automaker.children"
                                    :key="series_id"
                                    @click="checkedCar(car_object.id, automaker_id, series.id, automaker.name, series.name)"
                            >
                                <img :src="'/mini' + series.thumb" alt="series.name" v-if="series.thumb"/>
                                <img src="../../assets/images/brand_default.jpg" alt="暂无图片" v-else>
                                <span>{{ series.name }}</span>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>

            <!-- carslist end -->
        </el-dialog>

<!--        //弹框-->
        <el-dialog :visible.sync="dialogVisible_turntable" center class="turn_dialog">
            <div class="overall">
                <div class="zp-box">
                    <div class="panzi">
                        <div class="bck-box" :style="`transform: rotate(${-90+180/turn_list.length}deg)`">
                            <div
                                    class="bck"
                                    v-for="(i,index) in turn_list"
                                    :key="index"
                                    :style="`transform: rotate(${-index*360/turn_list.length}deg) skew(${-90 + 360/turn_list.length}deg);`"
                            ></div>
                        </div>
                        <div
                                class="jiang"
                                :style="`transform: rotate(${-index*360/turn_list.length}deg) translateY(-5.0rem);`"
                                v-for="(i,index) in turn_list"
                                :key="index"
                        >
                            <span class="title">{{i.title}}</span>
                            <div class="img">
                                <img :src="require('../../assets/images/tuanche/red_' + index + '.png')" alt />
                                <!--                        img{{index}}-->
                            </div>
                        </div>
                    </div>
                    <button class="start-btn" @click="start()" :disabled="loading">抽奖</button>
                </div>
            </div>
            <div class="turn_dialog_note" @click="get_notes()">红包规则</div>
        </el-dialog>

<!--        红包规则-->
        <el-dialog :visible.sync="dialogVisible_notes" width="90%" class="dialog_rules">
            <img src="../../assets/images/tuanche/rules.jpg" alt="红包规则" style="width: 100%; display: block; border-radius: 11px; box-shadow: -1px -1px 8px 7px rgba(0,0,0,.3);">
        </el-dialog>

<!--        红包-->
        <el-dialog :visible.sync="dialogVisible_money" width="88%" class="dialog_money">
            <p style="text-align: center; font-size: 22px; color: #ffe99b; font-weight: bold;">恭喜您获得{{getMoney}}</p>
            <div class="dialog_money_info">
                <span>{{getMoney}}</span>
            </div>
            <p style="font-size: 16px; color: #ffe99b; padding: 3%; box-sizing: border-box; border: 1px dashed #eb4437; border-radius: 11px;">转发报名页面，邀请好友报名，可获得额外红包奖励</p>
        </el-dialog>

    </div>
</template>

<script>
    import policy from "../../components/policy";
    import copyright from "../../components/copyright";
    import registered from "../../components/registered";
    import lib_activity from "../../libs/lib_activity";
    import lib_path from "../../libs/lib_path";
    import _time from "../../utils/_time";
    import _object from "../../utils/_object";
    import _wx from "../../common/_wx";
    import {isPhone} from "../../common/_validate";
    import { Message } from "element-ui";
    import _car from "../../common/_car";
    import _request from "../../common/_request";
    import cache_fans from '../../cache/cache_fans'
    import _base64 from "../../utils/_base64";
    import _config from "../../common/_config";
    import cache_copy_code from "../../cache/cache_copy_code";
    import _geturl_new from "../../utils/_geturl_new";


    let action_form = {
        brand_id: 0,
        automaker_id: 0,
        series_id: 0,
        name: "",
        phone: "",
        city: 0, //活动地址
        code: ''
    };
    let turn_list = [
        {
            title: '1.08'
        },
        {
            title: '1.68'
        },
        {
            title: '1.88'
        },
        {
            title: '2.88'
        },
        {
            title: '5.18'
        },
        {
            title: '5.88'
        },
        {
            title: '6.18'
        },
        {
            title: '6.88'
        },
        {
            title: '8.88'
        },
        {
            title: '9.99'
        }
    ]

    export default {
        name: "redpacket",
        components:{
            policy,
            copyright,
            registered,
        },
        data(){
            return{
                activity_id: 0, //活动ID
                tids: '',//模板ID
                channel: 0,//渠道ID
                template: {},//模板信息
                stime: 0,
                etime: 0,
                is_display: true,//底部按钮
                is_city: false,

                //count
                count_day: 0,
                count_hour: 0,
                count_minute: 0,
                count_second: 0,

                //表单
                action_form: action_form,
                rules: {
                    name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                    phone: [
                        { required: true, message: "请输入电话", trigger: "blur" },
                        { required: true, validator: isPhone, trigger: "blur" },
                    ],
                }, //验证
                is_overdue: false, //活动是否过期或禁用

                //品牌
                dialogVisible: false, //品牌弹框
                isShow: true, //车型弹框
                isactive: false, //获取点击字母
                checkedBrand: "请选择品牌车型",
                brandName: "",//品牌名称
                carName: "",//车型名称
                car_list: [], //品牌数据
                car_object: [], //车型数据
                is_carchecked: false,//是否选择车型

                //监测
                event_list: [],

                //城市联级选择
                citys: [], //城市数据
                cascaderProps: {
                    value: "id", //指定选项的值
                    label: "name", //指定选项标签
                    children: "children", //指定选项的子选项
                    emitPath: false, //该节点数组
                }, //配置项

                //短信验证码
                ismsgcode: 0, //是否短信验证
                countDown: '获取验证码',
                disabled_code: false,
                sms_val: '', //验证码值
                mobile_val: '', //验证码匹配手机号

                //红包
                is_redpack: 0,//是否红包
                dialogVisible_turntable: false, //转盘弹框
                turn_list:turn_list, //红包金额
                winner: 2, //指定获奖下标 specified为true时生效
                specified: false, //是否指定获奖结果，false时为随机
                loading: false, //抽奖执行状态，防止用户多次点击
                panziElement: null,
                getMoney: '', //获取红包金额
                user_info: {},
                share_link: '', //拼接分享链接
                sid: '',//分享人id
                _appid: '',//

                //红包
                dialogVisible_notes: false, //规则
                dialogVisible_money: false, //金额

            }
        },
        computed: {
            animationClass() {
                //对应css样式中定义的class属性值,如果有更多的话可以继续添加  case 8:   return 'wr8'
                switch (this.winner) {
                    case 0:
                        return 'wr0'
                    case 1:
                        return 'wr1'
                    case 2:
                        return 'wr2'
                    case 3:
                        return 'wr3'
                    case 4:
                        return 'wr4'
                    case 5:
                        return 'wr5'
                    case 6:
                        return 'wr6'
                    case 7:
                        return 'wr7'
                    case 8:
                        return 'wr8'
                    case 9:
                        return 'wr9'
                }
            }
        },
        created() {
            this.activity_id = _geturl_new('activity_id');
            this.tids = _geturl_new('tids');
            this.channel = _geturl_new('channel');
            this.ismsgcode = _geturl_new('ismsgcode');
            this.sid = _geturl_new('sid')

            this.getCode()


            // lib_activity.monitor(this.activity_id,this.monitor);
            lib_activity.selectedCitys(this.activity_id,this.init_city_list);
            _car.init(this.activity_id);
            this.get_time();
            window.addEventListener('scroll', this.handleScroll, true);
            //
            //通过获取奖品个数，来改变css样式中每个奖品动画的旋转角度
            // var(--nums) 实现css动画根据奖品个数，动态改变
            let root = document.querySelector(':root')
            root.style.setProperty('--nums', this.turn_list.length)
        },
        methods:{
            info(data) {
                document.title = data.theme;
                this.etime = data.etime;
                this.stime = data.stime;
                this.template = data.template
                this.is_city = data.is_city
                this.is_redpack = data.is_redpack

                if (!data.state || _time._current() > data.etime) {
                    this.is_overdue = true;
                    return;
                }

                // if(data.is_redpack == 1){
                //     this.getCode()
                // }


                if(data.hasOwnProperty('wx_share') && _object._length(data.wx_share)){
                    let options = {}
                    options.title = data.theme
                    options.desc = data.share_theme;
                    options.link = this.share_link;
                    options.image = window.location.protocol + '//' + window.location.host + data.template.thumb;
                    _wx.js_api(data.wx_share, _wx.share, options);
                }
            },

            //获取code
            getCode(){
                // //判断是否微信
                // this.is_weixin = (function() {
                //     return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
                // })();
                //
                // if(!this.is_weixin){
                //     this.$router.push({
                //             path: 'turntable',
                //             query: {
                //                 activity_id: this.activity_id,
                //                 tids: this.tids,
                //                 channel: this.channel,
                //                 ismsgcode: this.ismsgcode,
                //             }
                //         }
                //     )
                //     return;
                // }

                let self_sid = cache_fans.get();
                this.share_link = lib_path.redpacket(_base64._encode(self_sid));
                lib_activity.info(this.activity_id, this.tids, this.info);
                //lib_activity.info_news(this.activity_id, this.tids, _config._appid, this.share_link, this.info);

                // if(!cache_fans.empty()){
                //     // this.share_link += (cache_fans.empty()? '' : _base64._encode(cache_fans.get()));
                //     lib_activity.info_news(this.activity_id, this.tids, share_link, this.info);
                //     return;
                // }

                // let _local = window.location.href; // 获取页面url
                // this._appid = "wx18ce0876e2123ea3";
                // let code = _geturl_new('code'); // 截取code
                // if (code == null || code == "" || code == undefined){
                //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this._appid}&redirect_uri=${encodeURIComponent(
                //         _local
                //     )}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
                //     return;
                // }
                // lib_activity.code_to_openid(code,this._appid,function (data) {
                //     cache_fans.set(data)
                //     that.share_link += data;
                //
                //     lib_activity.info_news(that.activity_id, that.tids, that.share_link, that.info);
                // })
            },


            //倒计时
            get_time(){
                let date = Math.floor(Date.now()/1000);
                //时间差
                let count_time = this.stime - date;

                //定义变量 d,h,m,s保存倒计时的时间
                if (count_time >= 0) {
                    this.count_day = Math.floor(count_time / 60 / 60 / 24);
                    this.count_hour = Math.floor(count_time / 60 / 60 % 24);
                    this.count_minute = Math.floor(count_time / 60 % 60);
                    this.count_second = Math.floor(count_time % 60);
                }
                //递归每秒调用countTime方法，显示动态时间效果
                setTimeout(this.get_time, 1000);
            },

            //弹框
            clk_brand() {
                this.car_list = _car.get();
                this.dialogVisible = true;
            },
            //选择品牌
            toCarlist(brand) {
                this.car_object = brand;
                this.isShow = false;
                setTimeout(function () {
                    document.querySelector("#dialog_view").scrollIntoView();
                }, 1);
            },
            //选择车型
            checkedCar(brand_id, automaker_id, series_id, automaker_name, series_name) {
                this.dialogVisible = false;
                this.action_form.brand_id = brand_id;
                this.action_form.automaker_id = automaker_id;
                this.action_form.series_id = series_id;
                this.checkedBrand = automaker_name + " " + series_name;
                this.isShow = true;
                this.is_carchecked = true;
            },
            //字母
            toLetter(index) {
                this.isactive = index;
                document.querySelector("#letter_" + index).scrollIntoView();
            },

            //监测
            monitor(data){
                let _head = document.getElementsByTagName("head")[0];
                if(_object._length(data)){
                    for(let i in data){
                        let script = document.createElement('script');
                        script.append(data[i].base_code);
                        _head.appendChild(script);
                        this.event_list.push(data[i].event_code)
                    }
                }
            },
            //城市
            init_city_list(data) {
                this.citys = data;
            },

            //提交表单
            submitForm() {
                let that = this;
                if (!this.action_form.series_id) {
                    Message.info("请选择品牌车型");
                    return;
                }
                if(this.is_city == 1 && !this.action_form.city){
                    Message.info("请选择城市");
                    return;
                }
                if(this.ismsgcode == 1){
                    if(
                        !this.action_form.code
                        ||this.action_form.code != this.sms_val
                        ||this.action_form.phone != this.mobile_val){
                        Message.info("验证码不正确");
                        return;
                    }
                }

                this.$refs.action_form.validate((valid) => {
                    if (valid) {
                        let data = {
                            activity_id: this.activity_id,
                            channel: this.channel,
                            external_url: this.template.hasOwnProperty('id') ? window.location.href + '&ui_id=' + this.template.id : window.location.href + '&ui_id=0',
                            form_name: this.action_form.name,
                            form_mobile: this.action_form.phone,
                            form_brand_id: this.action_form.brand_id,
                            form_automaker_id: this.action_form.automaker_id,
                            form_series_id: this.action_form.series_id,
                            form_city_id: this.action_form.city,
                            form_ui_id: this.template.hasOwnProperty('id') ? this.template.id : 0,
                        };
                        _request._post(data, function (response) {
                            if (response.code !== _request.success) {
                                Message.info(response.info);
                                return;
                            }
                            that.user_info = response.data;

                            //清空表单
                            that.$refs.action_form.resetFields();

                            if(!response.data.hasOwnProperty('repeat') || response.data.repeat == 1)
                            {
                                Message.info('请勿重复报名');
                                return;
                            }

                            if(that.is_redpack == 0)
                            {
                                Message.info(response.info);
                                return;
                            }

                            if(cache_fans.empty()){
                                Message.info('恭喜您报名成功！');
                                return;
                            }

                            //打开转盘
                            that.dialogVisible_turntable = true;


                            // for(let i in that.event_list){
                            //     try {
                            //         if(that.event_list[i]){
                            //             eval(that.event_list[i])
                            //         }
                            //     }catch (e) {}
                            // }

                            // setTimeout(() => {
                            //     that.$router.push({
                            //         path: "level",
                            //         query: {
                            //             id: response.data.id,
                            //             tid: response.data.tid,
                            //             ticket: response.data.ticket,
                            //         },
                            //     });
                            // }, 2000);
                        },'/call/import/common_redpack');
                    }
                });
            },

            //置顶
            handleScroll: function(){
                let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollHeight >= 500){
                    this.is_display = false
                }else{
                    this.is_display = true
                }

            },
            toTop(){
                document.documentElement.scrollTop = 300 ;
                document.body.scrollTop = 300;
            },

            //验证码
            send(){
               let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
               let that = this;
               if(!this.action_form.phone){
                   Message('请输入手机号!')
                   return;
               }else if(!reg.test(this.action_form.phone)){
                   Message('手机号不合法')
                   return;
               }
               lib_activity.sms_code(this.action_form.phone,function (data) {
                   that.sms_val = data
                   that.mobile_val = that.action_form.phone
               })
               this.countTime()
            },
            //
            countTime(){
                let time = 60  //判断 时间为60s
                let timer = setInterval(() => {
                    if (time === 0) { //  当时间等于 0的时候
                        clearInterval(timer)  //清除时间
                        this.disabled_code = false // 让按钮的样式 为登陆状态
                        this.countDown = '获取验证码'   // 登陆状态的value文本
                        this.action_form.code = '' // 清除掉验证表单的值
                    } else {
                        this.countDown = time + 's后重新获取'   // 若时间大于则展示重新获取
                        this.disabled_code = true  // 判断显示文本的状态
                        time--  //将时间的一秒秒
                    }
                }, 1000)
            },

            //红包
            //开始抽奖
            start() {
                if (!this.loading) {
                    this.panziElement = document.querySelector('.panzi')
                    this.panziElement.classList.remove(this.animationClass)
                    if (this.specified) {
                        //此处可指定后端返回的指定奖品
                        // this.winner = this.winner
                        this.winCallback()
                    } else {
                        //this.winner = this.random(0, this.turn_list.length - 1)
                        this.winner = this.get_number();
                        this.winCallback();
                    }
                    this.loading = true
                }
            },
            //中奖返回方法
            winCallback() {
                setTimeout(() => {
                    /* 此处是为了解决当下次抽中的奖励与这次相同，动画不重新执行的 */
                    /* 添加一个定时器，是为了解决动画属性的替换效果，实现动画的重新执行 */
                    this.panziElement.classList.add(this.animationClass)
                }, 0)
                // 因为动画时间为 3s ，所以这里3s后获取结果，其实结果早就定下了，只是何时显示，告诉用户
                setTimeout(() => {
                    this.getMoney = this.turn_list[this.winner].title;
                    let data = {}
                    data.money = parseFloat(this.getMoney).toFixed(2);
                    data.activity_id = this.activity_id;
                    data.signup_id = this.user_info.id;
                    data.tid = this.user_info.tid;
                    data.openid = cache_fans.get();
                    data.sid = this.sid;
                    data.appid = _config._appid;
                    lib_activity.send_redpack(data,function (res) {})

                    this.dialogVisible_money = true;
                    this.dialogVisible_turntable = false;
                    //console.log(`恭喜你获得了${this.turn_list[this.winner].title}`)
                }, 3000)
            },
            //随机一个整数的方法
            random(min, max) {
                return parseInt(Math.random() * (max - min + 1) + min)
            },

            //随机算法
            get_number(){
                let number = this.random(0,1000)
                let caseNum = '';
                if(number === 0){
                    return caseNum = 9             //粗略概率为1% 9.99
                }else if(number === 1){
                    return caseNum = 8             //粗略概率为1% 8.88
                }else if(number === 2){
                    return caseNum = 7             //粗略概率为1% 6.88
                }else if(number === 3){
                    return caseNum = 6             //粗略概率为1% 6.18
                }else if(number === 4){
                    return caseNum = 5             //粗略概率为1% 5.88
                }else if(number === 5){
                    return caseNum = 4             //粗略概率为1% 5.18
                }else if(number >= 5 && number < 10){
                    return caseNum = 3             //粗略概率为10% 2.88
                }else if(number >= 10 && number < 20){
                    return caseNum = 2             //粗略概率为10% 1.88
                }else if(number >= 20 && number < 30){
                    return caseNum = 1             //粗略概率为10% 1.68
                }else{
                    return caseNum = 0  //粗略概率为40% 1.08
                }
            },

            //红包
            get_notes(){
                this.dialogVisible_notes = true;
            },


        },

        beforeRouteEnter(to, from, next){

            //openid
            if(!cache_fans.empty()){
                next();
                return;
            }
            //是否微信
            // let is_weixin = (function() {
            //     return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
            // })();
            // if(!is_weixin){
            //     next('turntable')
            // }

            let code = _geturl_new('code');

            let copy_code = cache_copy_code.get();
            let sid = _geturl_new('sid')

            if(!code || !copy_code){
                let _local = lib_path.redpacket(sid); // 获取页面url
                cache_copy_code.set(1)
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${_config._appid}&redirect_uri=${encodeURIComponent(
                    _local
                )}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
                return;
            }
            //获取oppenid
            lib_activity.code_to_openid(code,_config._appid,function (response) {
                cache_copy_code.set(0)
                if(response.code !== _request.success){
                    next('/turntable')
                }
                cache_fans.set(response.data);
                next();
            })

        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/style/autoshow/autoshow";
    @import "../../assets/style/autoshow/components/form";
    @import "../../assets/style/redpacket/turntable";
</style>
<style lang="less">
    .redpacket_code{
        .el-form-item__content{
            display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
            display: -moz-box; /* 老版本语法: Firefox (buggy) */
            display: -ms-flexbox; /* 混合版本语法: IE 10 */
            display: -webkit-flex; /* 新版本语法: Chrome 21+ */
            display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
            button{
                margin-left: 7px;
            }
        }
    }
    //转盘弹框
    .turn_dialog{
        .el-dialog{
            margin-top: 20% !important;
            background-image: url("../../assets/images/tuanche/dialog_bg.jpg");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            max-width: 640px;
            min-width: 320px;
            width: 88%;
            padding: 63% 0;
            background-color: rgba(255, 255, 255, 0);
            box-shadow: none;
        }
        .el-dialog__body{
            text-align: center;
            padding: 0 19px 30px !important;
        }
        .turn_dialog_money{
            padding-top: 15px;
            line-height: 27px;
            font-size: 14px;
            b{
                color: #f74e4e;
                font-size: 22px;
            }
        }
    }
    @import "../../assets/style/autoshow/components/dialog_cars";
    //红包弹框
    .dialog_money{
        .el-dialog{
            background-color: rgba(0,0,0,0);
            .dialog_money_info{
                background-image: url("../../assets/images/tuanche/money.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-position: center;
                font-size: 22px;
                font-weight: bold;
                color: #ffe99b;
                text-align: center;
                margin: 10% auto;
                width: 13rem;
                height: 14rem;
                position: relative;
                span{
                    display: block;
                    position: absolute;
                    top: 40%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
    //红包规则
    .dialog_rules{
        .el-dialog {
            box-shadow: none;
            background-color: rgba(0, 0, 0, 0);
        }
    }
</style>
